import { DeviceTypes } from "../../config/documents/HardwareConfig";
import { PoolDeviceInterface, IOnoffable } from "../Interfaces";
import Locale from "../../utils/Locale";
import PoolDeviceOnOffable from "./base-onoffable";
import { PoolDeviceCriticalDesiredActual, DisplayProcessingLogics } from "../Types";

export enum criticalFieldIdentifiers {
    OnOff = "OnOff"
}

export default class PoolDeviceBlower extends PoolDeviceOnOffable implements PoolDeviceInterface, IOnoffable {
    static CanBeAddedToflow = true;
    static Icon = "chart-bubble-material-community";
    static DeviceType = DeviceTypes.BLOWER;
    OnOffIdentifier = criticalFieldIdentifiers.OnOff;
    static PickerTitle = Locale.gettext("Blower");

    getCriticalFields():PoolDeviceCriticalDesiredActual[] {
        let order = 0;
        const fields = [];
    
        {
            const DisplayName = Locale.gettext("Power");
            const common = {
                DisplayName, DisplayNameShort: DisplayName,
                DisplayOrder: ++order,
                DisplayProcessingLogic: DisplayProcessingLogics.ONOFF,
                DisplayProcessingLogicUnitAsDisplayName: false,
            };
            fields.push({
                Identifier: criticalFieldIdentifiers.OnOff,
                ActualProperty: Object.assign({ Name: PoolsideDaemonDeviceStateNames.ActualPowerState }, common),
                DesiredProperty: Object.assign({ Name: PoolsideDaemonDeviceStateNames.PowerState }, common)
            });
        }
    
        return fields;
    }
    
}

export enum PoolsideDaemonDeviceStateNames {
    ActualPowerState = "ActualPowerState",
    PowerState = "PowerState"
}
